import React from 'react';
import PanelHeader from '../PanelHeader';
import { useEditor } from '../EditorContext';
import { isUploadedImage } from '../fabricHelpers';

export default function GoogleMapPanel() {
  const { selection, fabricRef } = useEditor();
  const img = isUploadedImage(selection) ? selection : null;

  const patch = (changes) => {
    if (!img) return;
    img.set(changes);
    fabricRef.current?.renderAll();
  };

  return (
    <div className="pixie-panel">
      <PanelHeader title="Google Map" icon="fa-map-location-dot" />
      {!img && (
        <p className="pixie-hint">Select an uploaded image on the canvas to configure map options.</p>
      )}
      {img && (
        <div className="pixie-props">
          <label className="pixie-field pixie-check">
            <input
              type="checkbox"
              checked={!!img.useGoogleMap}
              onChange={(e) => patch({ useGoogleMap: e.target.checked })}
            />
            Use Google Map Instead Image
          </label>
          <label className="pixie-field pixie-check">
            <input
              type="checkbox"
              checked={!!img.useUserGPS}
              onChange={(e) => patch({ useUserGPS: e.target.checked })}
            />
            Show Current User GPS on Map
          </label>
        </div>
      )}
    </div>
  );
}
